import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton } from 'react-share';

import MainContext from 'context/main';
import FacebookIcon from './svg/facebook.inline.svg';
import TwitterIcon from './svg/twitter.inline.svg';
import LinkedInIcon from './svg/linkedin.inline.svg';

import styles from './share.module.scss';

const cx = classNames.bind(styles);

const Share = ({ uri }) => {
  const {
    siteSettings: { siteUrl },
  } = useContext(MainContext);

  const url = siteUrl + uri;

  return (
    <ul className={cx('wrapper')}>
      <li className={cx('item')}>
        <FacebookShareButton className={cx('button')} url={url}>
          <FacebookIcon />
        </FacebookShareButton>
      </li>
      <li className={cx('item')}>
        <TwitterShareButton className={cx('button')} url={url}>
          <TwitterIcon />
        </TwitterShareButton>
      </li>
      <li className={cx('item')}>
        <LinkedinShareButton className={cx('button')} url={url}>
          <LinkedInIcon />
        </LinkedinShareButton>
      </li>
    </ul>
  );
};

Share.propTypes = {
  uri: PropTypes.string.isRequired,
};

export default Share;
